var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVsbc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 31.99,
    transform: "translate(0.494873 0.625)",
    fill: "#070709"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.494873,
    y: 0.625,
    width: 9.33333,
    height: 9.33,
    fill: "#0D0D0E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8281,
    y: 0.625,
    width: 9.33333,
    height: 9.33,
    fill: "#0D0D0E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.1616,
    y: 0.625,
    width: 9.33333,
    height: 9.33,
    fill: "#0D0D0E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.494873,
    y: 11.955,
    width: 9.33333,
    height: 9.33,
    fill: "#0D0D0E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8281,
    y: 11.955,
    width: 9.33333,
    height: 9.33,
    fill: "#0D0D0E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 23.1616,
    y: 11.955,
    width: 9.33333,
    height: 9.33,
    fill: "#0D0D0E"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 0.494873,
    y: 23.285,
    width: 9.33333,
    height: 9.33,
    fill: "#0D0D0E"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8281,
    y: 23.285,
    width: 9.33333,
    height: 9.33,
    fill: "#0D0D0E"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 23.1616,
    y: 23.285,
    width: 9.33333,
    height: 9.33,
    fill: "#0D0D0E"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 6.16162,
    y: 23.2851,
    width: 20.67,
    height: 9.33,
    rx: 2,
    fill: "#E9ECF5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVsbc);
export default __webpack_public_path__ + "static/media/VSBC.9261ab3bd5285d57623751a5144ea325.svg";
export { ForwardRef as ReactComponent };